import axios from '../utils/axios';

const API_URL = process.env.REACT_APP_API_URL + '/v1/admin/';

const base = (clinicId) => API_URL + 'clinics/' + clinicId + '/web-inquiry';

const getSettings = (clinicId) => axios.get(base(clinicId) + '/settings');

const updateSettings = (clinicId, data) => axios.put(base(clinicId) + '/settings', data);

const patchEnabled = (clinicId, enabled) =>
    axios.patch(base(clinicId) + '/settings/enabled', { enabled });

const regenerateKey = (clinicId) => axios.post(base(clinicId) + '/settings/regenerate-key');

const getAllowedDomains = (clinicId) => axios.get(base(clinicId) + '/allowed-domains');

const createAllowedDomain = (clinicId, data) => axios.post(base(clinicId) + '/allowed-domains', data);

const updateAllowedDomain = (clinicId, domainId, data) =>
    axios.put(base(clinicId) + '/allowed-domains/' + domainId, data);

const deleteAllowedDomain = (clinicId, domainId) =>
    axios.delete(base(clinicId) + '/allowed-domains/' + domainId);

const getNotifyRecipients = (clinicId) => axios.get(base(clinicId) + '/notify-recipients');

const createNotifyRecipient = (clinicId, data) =>
    axios.post(base(clinicId) + '/notify-recipients', data);

const updateNotifyRecipient = (clinicId, recipientId, data) =>
    axios.put(base(clinicId) + '/notify-recipients/' + recipientId, data);

const deleteNotifyRecipient = (clinicId, recipientId) =>
    axios.delete(base(clinicId) + '/notify-recipients/' + recipientId);

const getReasonOptions = (clinicId) => axios.get(base(clinicId) + '/reason-options');

const createReasonOption = (clinicId, data) => axios.post(base(clinicId) + '/reason-options', data);

const updateReasonOption = (clinicId, reasonId, data) =>
    axios.put(base(clinicId) + '/reason-options/' + reasonId, data);

const deleteReasonOption = (clinicId, reasonId) =>
    axios.delete(base(clinicId) + '/reason-options/' + reasonId);

const reorderReasonOptions = (clinicId, orderedIds) =>
    axios.post(base(clinicId) + '/reason-options/reorder', { orderedIds });

const sendTestInquiry = (clinicId) => axios.post(base(clinicId) + '/test-inquiry');

const webInquiryService = {
    getSettings,
    updateSettings,
    patchEnabled,
    regenerateKey,
    getAllowedDomains,
    createAllowedDomain,
    updateAllowedDomain,
    deleteAllowedDomain,
    getNotifyRecipients,
    createNotifyRecipient,
    updateNotifyRecipient,
    deleteNotifyRecipient,
    getReasonOptions,
    createReasonOption,
    updateReasonOption,
    deleteReasonOption,
    reorderReasonOptions,
    sendTestInquiry,
};

export default webInquiryService;
